// src/components/StickyCTA.jsx
import { Box, Button, IconButton, HStack, useBreakpointValue } from '@chakra-ui/react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';
import { useAnalytics } from '../hooks/useAnalytics';

const MotionBox = motion(Box);

export const StickyCTA = () => {
  const showCTA = useBreakpointValue({ base: true, md: false });
  const location = useLocation();
  const { trackEvent } = useAnalytics(); // Use the analytics hook

  // Pages where CTA should show
  const showCTAPages = ['/', '/beginner-track', '/experienced-track', '/why-us', '/webinar'];
  const shouldShowCTA = showCTAPages.includes(location.pathname);

  // Don't show CTA if it's hidden by breakpoint OR not on allowed pages
  if (!showCTA || !shouldShowCTA) return null;

  // Dynamic CTA logic
  const isWebinarPage = location.pathname === '/webinar';
  const label = isWebinarPage ? 'Enroll Now' : 'Join Free Webinar';
  const link = isWebinarPage ? '/enroll?courseId=1' : '/webinar';

  const handleCTAClick = () => {
    console.log('GA Event: mobile_cta_click');
    trackEvent('mobile_cta_click', {
      page: location.pathname,
      label: label,
    });
  };

  const handleWhatsAppClick = () => {
    console.log('GA Event: whatsapp_chat_click');
    trackEvent('whatsapp_chat_click', {
      page: location.pathname,
    });
  };

  return (
    <MotionBox
      initial={{ y: 80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.4 }}
      position="fixed"
      bottom="0"
      left="0"
      width="100%"
      p={3}
      zIndex="998"
      shadow="lg"
      borderTop="1px"
      borderColor="gray.100"
      bg="white"
    >
      <HStack
        spacing={4}
        width="100%"
        maxW="container.sm"
        mx="auto"
        align="center"
        justify="space-between"
      >
        {/* Primary CTA - Left side */}
        <Button
          as={RouterLink}
          to={link}
          size="md"
          flex="1"
          colorScheme="green"
          borderRadius="full"
          onClick={handleCTAClick}
          fontWeight="semibold"
          fontSize={{ base: 'sm', sm: 'md' }}
          px={4}
        >
          {label}
        </Button>

        {/* WhatsApp button - Right side */}
        <IconButton
          as="a"
          href="https://wa.me/919900309000"
          target="_blank"
          rel="noopener noreferrer"
          icon={<FaWhatsapp />}
          colorScheme="whatsapp"
          size="md"
          isRound
          aria-label="Chat on WhatsApp"
          shadow="md"
          onClick={handleWhatsAppClick}
          flexShrink={0}
        />
      </HStack>
    </MotionBox>
  );
};